import { Methods } from "@newview/infrastructure";
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class TheMemoApi extends NewviewOaBaseApi {

  public get ControllerName(): any {
    return 'theMemo'
  }

}